import { render, staticRenderFns } from "./GeoscriptMetadata.vue?vue&type=template&id=46c6185a&"
import script from "./GeoscriptMetadata.vue?vue&type=script&lang=js&"
export * from "./GeoscriptMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports